<template>
    <div class="error-content text-center mt-3">
        <h3><i class="fa fa-warning text-yellow"></i> {{ title }}</h3>
        <p v-html="description"></p>
    </div>
</template>

<script>
    export default {
        name: 'ProductRecordNotFound',
        props: {
            title: {
                default: 'Sorry! No Products Found.'
            },
            description: {
                default: 'Sorry, no products were found. Please try different filters.'
            }
        }
    };
</script>
